import { ApiErrorState } from "../shared/ApiErrorState";
import { LeaderboardProvider } from "../../context/LeaderboardProvider";
import { useLeaderboard } from "../../hooks/useLeaderboard";
import { HomeTabs } from "./HomeTabs";
import { RoutePageMeta } from "../../seo/RoutePageMeta";

const LeaderboardPageContent = () => {
  const { error } = useLeaderboard();

  return (
    <div className="mx-auto min-h-screen w-[92%] max-w-7xl bg-transparent px-0 pb-10 pt-28 font-shentox text-[#e8e8ef] max-[900px]:w-full max-[900px]:px-[var(--padding-view)] max-[900px]:pb-8 max-[900px]:pt-[6.5rem]">
      <RoutePageMeta page="LEADERBOARD" />
      {error ? (
        <div className="pb-16 pt-10">
          <section className="surface-card overflow-hidden max-[900px]:overflow-visible">
            <ApiErrorState message={error} className="p-8 text-center text-[#8b8b9a]" />
          </section>
        </div>
      ) : (
        <HomeTabs />
      )}
    </div>
  );
};

export const LeaderboardPage = () => (
  <LeaderboardProvider>
    <LeaderboardPageContent />
  </LeaderboardProvider>
);
